module.exports = __webpack_public_path__ + "static/media/comment-white.cef80e68.svg";